export enum Privacy {
  ALL = 'All',
  COACH_ONLY = 'Coach Only'
}